import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=367506f0&scoped=true"
import script from "./CallToAction.vue?vue&type=script&lang=js"
export * from "./CallToAction.vue?vue&type=script&lang=js"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=367506f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367506f0",
  null
  
)

export default component.exports